module.exports = __webpack_public_path__ + "img/taskbg.34460e54.png";